import "./CourseItem.scss";
import ModuleItem from "./ModuleItem";
import CourseDetails from "components/CourseDetails/CourseDetails";

const CourseItem = ({ course, expandedModuleId, onExpand, supressExpand, previewMode = false, previewLockedLearningJourneys = false }) => {
	const courseId = course.Id;

	return (
		<div className="list-view-item" id={`courseId-${courseId}`}>
			<CourseDetails course={course} previewMode={previewMode} />

			<h3>Modules</h3>

			{(course.SubContent ?? []).map((module, index) => {
				const moduleId = module.Id;
				const key = `course-${courseId}-module-${moduleId}-row-${index}`;

				return (
					<div key={key}>
						<ModuleItem
							module={module}
							course={course}
							expandedModuleId={expandedModuleId}
							onExpand={onExpand}
							supressExpand={supressExpand}
							previewMode={previewMode}
							previewLockedLearningJourneys={previewLockedLearningJourneys}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default CourseItem;